export default {"src":"/_next/static/media/key_64.893120b9.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};